import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { ChatBotStateService } from '../../shared/chat-bot-state.service';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { ReferralPageBannerService } from '../referral-page-banner/referral-page-banner.service';
import { GTMService } from '../../shared/gtm.service';
import { ChatBotTrackEvents } from '../../shared/types/chat-bot-track-events.enum';

export enum BannerType {
  Onboarding,
  Referral,
  ChatBot
}

export const BANNER_KEY = 'banner-type';

@Component({
  selector: 'lp2-banner-roulette',
  template: `
    <lp2-onboarding-banner *ngIf="bannerType === bannerTypeEnum.Onboarding" [backgroundColor]="onboardingBackgroundColor"></lp2-onboarding-banner>
    <lp2-referral-page-banner *ngIf="bannerType === bannerTypeEnum.Referral"></lp2-referral-page-banner>
    <lp2-chat-bot-banner *ngIf="bannerType === bannerTypeEnum.ChatBot" (openChatBotModal)="openChatBotModal()"></lp2-chat-bot-banner>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BannerRouletteComponent implements OnInit {

  public onboardingBackgroundColor: string;
  public bannerType: BannerType;
  public bannerTypeEnum = BannerType;

  constructor(
    private readonly oeAppPersonService: OeAppPersonService,
    private readonly chatBotStateService: ChatBotStateService,
    private readonly referralPageBannerService: ReferralPageBannerService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly gtmService: GTMService
  ) {}

  ngOnInit() {
    this.defineOnboardingBackgroundColor();
    this.setBannersAvailability();
  }

  public openChatBotModal() {
    this.chatBotStateService.openChatBotModal();
    this.chatBotStateService.hideBanner();
    this.chatBotStateService.showHeaderButton();
    this.gtmService.sendGA4Event(ChatBotTrackEvents.COPILOT_BANNER_SPEAK_WITH_JENNY);
  }

  private setBannersAvailability() {
    combineLatest([
      this.chatBotStateService.state$.pipe(map(({ showBanner }) => showBanner)),
      this.referralPageBannerService.showBanner$
    ]).subscribe(([showChatBotBanner, displayReferralBanner]) => {
      if (displayReferralBanner !== null) {
        const bannerTypeMap = {
          [BannerType.Onboarding]: this.oeAppPersonService.getShowOnboardingBanner(),
          [BannerType.Referral]: displayReferralBanner,
          [BannerType.ChatBot]: showChatBotBanner
        }
      
        const currentBannerType = localStorage.getItem(BANNER_KEY);
        // Compiled enum has both keys and values, so we divide by 2 to get the total number of types
        const totalTypes = Object.keys(BannerType).length / 2;
        let startIndex = Number(currentBannerType);
        let nextBannerType: BannerType;
      
        while (!nextBannerType) {
          startIndex = (startIndex + 1) % totalTypes;
          if (bannerTypeMap[startIndex]) {
            nextBannerType = startIndex;
            this.updateBanner(nextBannerType);
            return;
          }
          if (startIndex === Number(currentBannerType)) {
            this.clearBannerData();
            return;
          }
        }
  
      }
    });
  }

  private updateBanner(bannerType: BannerType) {
    localStorage.setItem(BANNER_KEY, String(bannerType));
    this.bannerType = bannerType;
    this.cdRef.detectChanges();
    setTimeout(() => window.scrollTo(0, 0), 500);
  }

  private clearBannerData() {
    localStorage.removeItem(BANNER_KEY);
    this.bannerType = null;
    this.cdRef.detectChanges();
  }

  private defineOnboardingBackgroundColor() {
    const colors = {
      '$bg-light-blue': '#edf6ff',
      '$bg-white': '#fff',
    };

    if (this.oeAppPersonService.liveClassEnabled) {
      this.onboardingBackgroundColor = colors['$bg-white'];
    } else {
      this.onboardingBackgroundColor = colors['$bg-light-blue'];
    }
  }

}



// WEBPACK FOOTER //
// ./ts/app/home/banner-roulette/banner-roulette.component.ts